import { useState } from "react";

export type ConfirmState = {
  message: string;
  onConfirm: () => void | Promise<void>;
  destructive?: boolean;
} | null;

/** State for one `ConfirmDialog`: ask with a message + action, run it on «yes». */
export function useConfirmDialog() {
  const [confirmState, setConfirmState] = useState<ConfirmState>(null);

  const askConfirm = (
    message: string,
    onConfirm: () => void | Promise<void>,
    destructive = false
  ) => setConfirmState({ message, onConfirm, destructive });

  const handleConfirmYes = async () => {
    if (!confirmState) return;
    const { onConfirm } = confirmState;
    setConfirmState(null);
    await onConfirm();
  };

  const closeConfirm = () => setConfirmState(null);

  return { confirmState, askConfirm, handleConfirmYes, closeConfirm };
}
